<template>
  <popover-right v-model="isShow" width="1000px" :closed="cancel" class="message-new-custome-con">
    <h1 class="popover-right-title">{{getDate(detail.begin_ts)}} 至 {{getDate(detail.end_ts)}} 新客户汇总</h1>
    <div class="tips-con">
      <p class="tip-total">本{{detail.statistic_type == 3 ? '周' : '月'}}新增 {{detail.total_new || 0}} 名客户， 1 小时跟进率是 {{detail.follow_rate * 100}}%</p>
      <p class="tip-total">截止到 {{parseTime(detail.end_ts * 1000, '{y}年{m}月{d}日')}} 有 {{detail.public_pool || 0}} 名客户进入公客池, {{detail.invalid_pool || 0}} 名客户进入无效池, {{detail.black_pool || 0}} 名客户进入黑名单, {{detail.stage_str}}。</p>
      <p class="tip-suggest">使用建议：当1小时跟进率低于公司平均值时，展示首次跟进时长较长，需要督促经纪人及时跟进，否则不展示。</p>
    </div>
    <div class="search-btn-con">
      <div class="search-flex">
        <span class="label">手机号</span>
        <el-input v-model="condition.contact_tel" placeholder="请输入" size="small" style="width: 175px;" clearable />
      </div>
      <div class="search-flex">
        <span class="label">统计时的客户状态</span>
        <el-select v-model="condition.customer_stage" placeholder="请选择" size="small" clearable >
          <el-option label="全部" value=""></el-option>
          <el-option :label="value" :value="key" v-for="(value, key) in options.customer_follow_up_stage_all" :key="key"></el-option>
        </el-select>
      </div>
      <div class="search-flex">
        <span class="label">来源方式</span>
        <el-select v-model="condition.customer_source" placeholder="请选择" size="small" clearable >
          <el-option label="全部" value=""></el-option>
          <el-option :label="value" :value="key" v-for="(value, key) in options.customer_sources" :key="key"></el-option>
        </el-select>
      </div>
      <el-button class="global-btn primary" type="mini" @click="handleSearch">查询</el-button>
    </div>
    <div class="message-table-con">
      <p class="msg-end-time">统计时间截止到：{{parseTime(detail.end_ts * 1000, '{y}-{m}-{d} {h}:{i}:{s}')}}</p>
      <cu-table :isLoading="isLoading" :pageData="pageCon" :data="list" @currentChange="currentChange" class="message-table">
        <el-table-column label="客户姓名" min-width="120">
          <template slot-scope="scope">
            <p class="apply-table-cursor" @click="handleToDetail(scope.row)">{{scope.row.customer_name || '--'}}</p>
          </template>
        </el-table-column>
        <el-table-column label="手机号" min-width="100">
          <template slot-scope="scope">
            {{scope.row.contact_tel || '--'}}
          </template>
        </el-table-column>
        <el-table-column label="首次跟进时长" min-width="120">
          <template slot-scope="scope">
            {{scope.row.follow_duration_str || '--'}}
          </template>
        </el-table-column>
        <el-table-column label="统计时的客户状态" min-width="120">
          <template slot-scope="scope">
            {{scope.row.customer_stage_name || '--'}}
          </template>
        </el-table-column>
        <el-table-column label="所处客户池" min-width="120">
          <template slot-scope="scope">
            {{scope.row.customer_status_name || '--'}}
          </template>
        </el-table-column>
        <el-table-column label="统计时的归属人" min-width="120">
          <template slot-scope="scope">
            {{scope.row.admin_name || '--'}}
          </template>
        </el-table-column>
        <el-table-column label="来源方式" min-width="120">
          <template slot-scope="scope">
            {{scope.row.customer_source_name || '--'}}
          </template>
        </el-table-column>
        <el-table-column label="创客时间" min-width="150">
          <template slot-scope="scope">
            <p v-analysis-time:all="scope.row.customer_create_time"></p>
          </template>
        </el-table-column>
      </cu-table>
    </div>
  </popover-right>
</template>
<script>
import PopoverRight from '@/components/popover/index';
import CuTable from '@/components/cTable';
import {getXiaoyunDetail, getXiaoyunNewCustomeList} from '@/api/workspace';
import {parseTime} from '@/utils';
export default{
  name: 'MessageNewCustome',
  components: {
    PopoverRight,
    CuTable
  },
  props: {
    value: String,
    subclass: Number,
    id: Number,
    emitName: {
      type: String,
      default: ''
    }
  },
  computed: {
    isShow () {
      return this.value === 'messageNewCustome';
    }
  },
  data () {
    return {
      detail: {},
      parseTime: parseTime,
      options: {},
      condition: {
        customer_stage: '',
        contact_tel: '',
        customer_source: ''
      },
      pageCon: {
        page: 1,
        per_page: 10,
        total: 0
      },
      isLoading: false,
      list: []
    }
  },
  async created() {
    this.initDetail();
    this.initList();
    this.options = await this.$store.dispatch('initConfig', ['customer_follow_up_stage_all', 'customer_sources']);
  },
  methods: {
    getDate (time = 0) {
      return parseTime(new Date(time * 1000), '{y}-{m}-{d}');
    },
    async initDetail () {
      try {
        const res = await getXiaoyunDetail({
          subclass: this.subclass,
          id: this.id
        });
        this.detail = res && res.extra || {};
      } catch (error) {
        this.detail = {};
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
    async initList () {
      if (this.condition.contact_tel && !/^\d{11}$/.test(this.condition.contact_tel)) {
        this.$message.error('手机号格式为11个数字类型');
        return null;
      }
      this.isLoading = true;
      try {
        const res = await getXiaoyunNewCustomeList({
          message_id: this.id,
          ...this.condition,
          ...this.pageCon
        });
        this.list = res.data || [];
        this.$set(this.pageCon, 'total', res.total);
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      } finally {
        this.isLoading = false;
      }
    },
    cancel () {
      this.$emit('input', '');
    },
    handleSearch () {
      this.pageCon.page = 1;
      this.initList();
    },
    currentChange (page) {
      this.pageCon.page = page;
      this.initList();
    },
    handleToDetail (row) {
      this.$EventBus.$emit(this.emitName, {category: 'customerDetail', params: {
        customerId: Number(row.customer_id)
      }})
    }
  },
}
</script>
<style lang="less" scoped>
.message-new-custome-con{
  .tips-con{
    padding: 20px;
  }
  .tip-total{
    font-size: 14px;
    color: #333;
    line-height: 25px;
    padding-bottom: 5px;
  }
  .tips-info{
    color: #ff0a0a;
    font-size: 13px;
    line-height: 20px;
  }
  .tip-suggest{
    font-size: 13px;
    color: #666;
    margin-top: 5px;
    line-height: 25px;
  }
  .search-btn-con{
    .box(start, start);
    padding: 20px;
  }
  .search-flex{
    margin-right: 10px;
  }
  .label{
    font-size: 13px;
    color: #666;
    margin-right: 10px;
  }
  .message-table{
    width: 100%;
    padding: 0 20px;
  }
  .msg-end-time{
    padding: 0 0 10px 20px;
    font-size: 12px;
    color: #999;
  }
}
</style>
<style lang="less">
.message-new-custome-con{
  .modify-container{
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
  .message-table-con{
    .boxFlexAll();
    -webkit-box-flex: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    padding-bottom: 20px;
    .message-table{
      .boxFlexAll();
      min-height: 400px;
    }
  }
}
</style>